export class CrtMonthlyAggregate {
  removalYear: Date;
  removalMonth: number;
  removalDate: number;
  flightHours: string;
  flightCycles: number;
  totalRemovals: number;
  metricsValidRemovals: number;
  unscheduledRemovals: number;
  nonzeroUnscheduledRemovals: number;
  badFromStockRemovals: number;
  unschedOrBfsRemovals: number;
  totalBadFromStockRate: number;
  unschedBadFromStockRate: number;
  totalNoFaultFoundRate: number;
  unschedNoFaultFoundRate: number;
  metricsValidNffRate: number;
  mtbur: number;
  mcbur: number;
  unschedRate10kHours: number;
  unschedRate10kCycles: number;
  orderId: number;
}
